module.exports = __webpack_public_path__ + "img/Adjustable.a578bef2.png";